<template>
  <div class="the-navbar__user-meta flex items-center">
    <div class="con-img ml-3">
      <img
        key="onlineImg"
        :src="logo"
        width="40"
        height="40"
        class="rounded-full shadow-md block"
      />
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="ml-3 mt-1">
        <div class="text-right leading-tight sm:block">
          <p class="font-semibold">{{ userName }}</p>
        </div>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 13rem">
          <!--          <li-->
          <!--            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
          <!--          >-->
          <!--            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />-->
          <!--            <span class="ml-2">組織設定</span>-->
          <!--          </li>-->

          <li class="flex py-2 px-2">
            <span class="ml-2 font-semibold">法人ID : {{ userId }}</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="onLogout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2 font-semibold">ログアウト</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      logo: require("@/assets/images/icons/lolcal/office.svg"),
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    hasUser() {
      const { user } = this;
      if (!(user !== null && typeof user === "object")) return false;
      return typeof user.name === "string" && typeof user.id === "string";
    },
    userName() {
      if (!this.hasUser) return "";
      return this.user.name;
    },
    userId() {
      if (!this.hasUser) return "";
      return this.user.id;
    },
  },
  methods: {
    ...mapActions({
      logout: "auth/logout",
    }),
    async onLogout() {
      await this.logout();
      this.$vs.notify({
        title: "ログアウトしました",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });
    },
  },
};
</script>

<style lang="scss"></style>
